import { call, put, takeEvery} from "redux-saga/effects";
import {
  GET_CITY_DEFINITIONS,
  ADD_CITY_DEFINITION,
  UPDATE_CITY_DEFINITION,
  DELETE_CITY_DEFINITION
} from "./actionTypes"

import {

  getCityDefinitionSuccess,
  addCityDefinitionSuccess,
  updateCityDefinitionSuccess,
  deleteCityDefinitionSuccess,
  cityDefError
  
} from "./actions"

//Include Both Helper File with needed methods
import {

addCityDefinition,
updateCityDefinition,
deleteCityDefinition,
getCityDefinition

} from "../../helpers/backend_helper/backend_helper"

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';

function* fetchCityDefinition() {
  try {
    const response = yield call(getCityDefinition)
    yield put(getCityDefinitionSuccess(response))
  } catch (error) {
    yield put(cityDefError(error))
  }
}

function* onAddCityDefinition({ payload: record }) {
  try {
    const response = yield call(addCityDefinition, record)
    yield put(addCityDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(cityDefError(error))
  }
}

function* onUpdateCityDefinition({ payload: record }) {
  try {
    const response = yield call(updateCityDefinition, record)
    yield put(updateCityDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(cityDefError(error))
  }
}

function* onDeleteCityDefinition({ payload: guid }) {
  try {
    const response = yield call(deleteCityDefinition, guid)
    yield put(deleteCityDefinitionSuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(cityDefError(error))
  }
}


function* cityDefManagementSaga() {

    yield takeEvery(GET_CITY_DEFINITIONS,fetchCityDefinition)
    yield takeEvery(ADD_CITY_DEFINITION,onAddCityDefinition)
    yield takeEvery(UPDATE_CITY_DEFINITION,onUpdateCityDefinition)
    yield takeEvery(DELETE_CITY_DEFINITION,onDeleteCityDefinition)
}

export default cityDefManagementSaga
